import { cn } from '../../lib/utils';

interface LogoProps {
  className?: string;
}

export default function Logo({ className }: LogoProps) {
  return (
    <img
      src="/logo.png"
      alt="BIX Tech"
      className={cn('h-8 w-auto select-none', className)}
      draggable={false}
    />
  );
}
